@if (isLoading()) {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else {
  <p class="name" (click)="copyToClipboard(name)">{{ name }}<mat-icon class="copy-icon">content_copy</mat-icon></p>

  @for (profileHeader of topProfileHeaders$ | async; track $index) {
    <crm-dynamic-profile-header-cards
      class="profile-header-card"
      [component]="profileHeader.component"
      [crmObject]="crmObject"
      [crmObjectType]="objectType()"
    ></crm-dynamic-profile-header-cards>
  }

  <p class="subtitle subtitle-color">{{ subtitle }}</p>
  <a href="{{ website }}" target="_blank" class="subtitle">{{ website }}</a>

  @for (profileHeader of bottomProfileHeaders$ | async; track $index) {
    <crm-dynamic-profile-header-cards
      class="profile-header-card"
      [component]="profileHeader.component"
      [crmObject]="crmObject"
      [crmObjectType]="objectType()"
    ></crm-dynamic-profile-header-cards>
  }

  <div class="contact-buttons">
    @if (onClickOpenConversation) {
      <button
        mat-icon-button
        [glxyTooltip]="'CONTACT.PROFILE_PAGE.CHAT_ICON_TOOLTIP' | translate"
        class="contact-button"
        (click)="onClickOpenConversation()"
      >
        <mat-icon>question_answer</mat-icon>
      </button>
    }
    @if (phone) {
      <a
        href="tel:{{ phone }}"
        mat-icon-button
        [glxyTooltip]="'CONTACT.PROFILE_PAGE.PHONE_ICON_TOOLTIP' | translate"
        class="contact-button"
      >
        <mat-icon>phone</mat-icon>
      </a>
    }
    @if (showMeetingIcon) {
      <a
        mat-icon-button
        [glxyTooltip]="'CONTACT.PROFILE_PAGE.MEETING_ICON_TOOLTIP' | translate"
        class="contact-button"
        (click)="openMeetingEventListDialog()"
      >
        <img [src]="calendarImgUrl" alt="" />
      </a>
    }
    @if (email) {
      <a
        href="mailto:{{ email }}"
        mat-icon-button
        [glxyTooltip]="'CONTACT.PROFILE_PAGE.EMAIL_ICON_TOOLTIP' | translate"
        class="contact-button"
      >
        <mat-icon>email</mat-icon>
      </a>
    }
    @if (onClickEdit) {
      <button mat-icon-button class="contact-button" [matMenuTriggerFor]="moreMenu">
        <mat-icon>more_horiz</mat-icon>
      </button>
    }
  </div>

  <mat-menu #moreMenu="matMenu">
    @if (objectType(); as objectType) {
      @if (onClickEdit) {
        <button mat-menu-item (click)="onClickEdit()">
          {{ 'PROFILE_PAGE.EDIT' | translateForCrmObject: objectType | async }}
        </button>
      }
    }
  </mat-menu>
}
